import { useLocation, useSearchParams } from 'react-router-dom';
import HomePage from '../pages/page/index';
import { useCallback, useEffect, useState } from 'react';
import { AxiosError } from 'axios';
import { Config, Data } from '@measured/puck';
import {
  AxonTracker,
  checkoutService,
  CheckoutSkeleton,
  extractAndUseTrackers,
  GoogleAdsTracker,
  // GoogleAdsTracker,
  GTMTracker,
  GTMTrackerCustom,
  GTMTrackerForThakyouPage,
  LoadingPage,
  // LoadingPage,
  NewsBreakTracker,
  RetentionPixelTracker,
  showNotification,
  SnapPixelTracker,
  StatusCode,
  TripleWhaleTracker,
  ConvertTracker,
} from 'shared-components';
import checkoutConfig from 'puck/checkout-puck-config';
import { ConvertBase64ToJson } from 'shared-components';
import { isEmpty } from 'lodash';
import { StartCheckoutPayload } from 'shared-components/src/page-builder/interface/apiServiceInterface';
import ErrorMessage from 'components/error-message';
import { IErrorResponse } from 'shared-components/src/page-builder/interface/apiInterface';
import {
  setApplePay,
  setCartData,
  setGooglePay,
  setIsCartLoading,
  setPromoCodes,
} from 'shared-components/src/page-builder/redux/slices/cartSlice';
import { setStoreData } from 'shared-components/src/page-builder/redux/slices/storeSlice';
import { useAppSelector } from 'hooks/reduxHooks';
import { useDispatch } from 'react-redux';
import { DESIGN_ID_ENABLED_STORES, PageType } from 'utils/constant';
import {
  setApiLoading,
  setAvailableShippingMethods,
  setCurrentPageFunnelId,
  setIsDeclinePopup,
  setIsSetShippingApiLoading,
  setNextPageConfig,
  setPageId,
  setPurchaseToken,
  setSelectedShippingMethod,
} from 'shared-components/src/page-builder/redux/slices/checkoutSlice';
import {
  CountryWithStateList,
  ShippingMethod,
  GetPreCheckoutUpSellPayload,
  handleCapi,
} from 'shared-components';
import { setCountriesList } from 'shared-components/src/page-builder/redux/slices/CountryInfoSlice';
import {
  setPreUpsellData,
  setPreUpsellLoading,
} from 'shared-components/src/page-builder/redux/slices/preUpsellSlice';
import {
  setCurrentUpsellData,
  setPostUpsellData,
  setSelectedUpsellItems,
  setSelectedVariantForSingleProduct,
  setSmartUpsellFunnelID,
  setUpsellData,
} from 'shared-components/src/page-builder/redux/slices/postUpsellSlice';
import PageNotFound from 'components/NotFoundPage';
import { setOrderDetails } from 'shared-components/src/page-builder/redux/slices/orderDetailsSlice';
import { Tracker } from 'shared-components/src/page-builder/utils/trackers/trackers';
import { EventPublisher } from 'shared-components/src/page-builder/utils/publishEvent';
import { getIsViewIsEdit } from 'shared-components/src/page-builder/utils/constants';
import {
  setCallMetaApi,
  setSalexTaxEnabled,
  setCheckoutErrorMessage,
  setSubmitSuccess,
  setIsPaymentByPaypal,
  setCalculatedFeeEnabled,
} from 'shared-components/src/page-builder/redux/slices/commonSlice';
import { Cart } from 'shared-components/src/page-builder/interface/checkoutInterface';
import { handleEventLogger } from 'shared-components/src/page-builder/utils/conversionAPI';
import {
  setIsLoading,
  setShowPopup,
} from 'shared-components/src/page-builder/redux/slices/postUpsellStateSlice';
import { ExtendedRootFieldProps } from 'shared-components/src/page-builder/interface/pageInterface';
import { v4 as uuidv4 } from 'uuid';
import { postUpsellPage } from 'shared-components/src/page-builder/utils/postUpsell';
import { useNavigate } from 'react-router-dom';
import { RedditTracker } from 'shared-components/src/page-builder/utils/trackers/reddit/tracker';

const Home = () => {
  const { state } = useLocation();
  const dispatch = useDispatch();
  const storeData = useAppSelector(state => state.store.storeData);
  const [searchParams] = useSearchParams();
  const shopId = searchParams.get('store');
  const cartId = searchParams.get('cart');
  const designID = searchParams.get('designStoreID');
  const isMockApi = searchParams.get('use-mock-api') === 'true';
  const navStateID = state?.id;
  const smartFunnelId = state?.smartFunnelId;
  const trafficSource = searchParams.get('trafficSource');
  const possibleKeys = ['click_id', 'cid', 'twclid', 'clickid'];
  const clickid = possibleKeys
    .map(key => searchParams.get(key))
    .find(value => value !== null);
  const [error, setError] = useState<string>('');
  const [loading, setLoading] = useState<number>(0);
  const [puckConfig, setPuckConfig] = useState<Config | null>();
  const [puckData, setPuckData] = useState<Data>();
  const purchaseToken = useAppSelector(state => state.checkout.purchaseToken);
  const publish = EventPublisher.getInstance().publish;
  const eventToken = searchParams.get('event-token');
  const [pixelData, setPixelData] = useState({
    isEventHoisted: false,
    phxRequestId: '',
  });
  const puckRootData = puckData?.root?.props as ExtendedRootFieldProps;

  const [pixelEvent, setPixelEvent] = useState<Tracker[]>([]);
  const [metaTickTokTracker, setMetaTikTokTracker] = useState<{
    meta: string[];
    tiktok: string[];
  }>({
    meta: [],
    tiktok: [],
  });
  const cartData = useAppSelector(state => state.cart.cartData);
  const thankyouPagePixelStoreIds = ['0x9suh-gz'];
  const navigate = useNavigate();

  if (!shopId || (!navStateID && !purchaseToken && !cartId)) {
    return <PageNotFound />;
  }
  const getPixel = async () => {
    try {
      const pixel: Tracker[] = [];
      const res = await checkoutService.getPixel(input1);
      if (res?.data?.Pixel) {
        if (res?.data?.Pixel?.META?.code) {
          // pixel.push(new MetaTracker(res?.data?.Pixel?.META?.code));
          setMetaTikTokTracker(pre => {
            return {
              ...pre,
              meta: res?.data?.Pixel?.META?.code,
            };
          });
        }
        if (res?.data?.Pixel?.SNAP?.code) {
          pixel.push(new SnapPixelTracker(res?.data?.Pixel?.SNAP?.code));
        }
        if (res?.data?.Pixel?.TIKTOK?.code) {
          // pixel.push(new TikTokTracker(res?.data?.Pixel?.TIKTOK?.code));
          setMetaTikTokTracker(pre => {
            return {
              ...pre,
              tiktok: res?.data?.Pixel?.TIKTOK?.code,
            };
          });
        }
        if (res?.data?.Pixel?.APPLOVIN?.code) {
          pixel.push(new AxonTracker(res?.data?.Pixel?.APPLOVIN?.code));
        }
        if (res?.data?.Pixel?.NEWSBREAK?.code) {
          pixel.push(new NewsBreakTracker(res?.data?.Pixel?.NEWSBREAK?.code));
        }
        if (res?.data?.Pixel?.RETENTION?.code) {
          pixel.push(
            new RetentionPixelTracker(res?.data?.Pixel?.RETENTION?.code),
          );
        }
        if (res?.data?.Pixel?.['TRIPLE-WHALE']?.code) {
          pixel.push(
            new TripleWhaleTracker(res?.data?.Pixel?.['TRIPLE-WHALE']?.code),
          );
        }
        const redditPixelCode = res?.data?.Pixel?.REDDIT?.code;

        if (redditPixelCode) {
          pixel.push(new RedditTracker(redditPixelCode));
        } else {
          console.warn(
            '[RedditTracker] Pixel code is missing or invalid:',
            redditPixelCode,
          );
        }
        if (
          res?.data?.Pixel?.['GOOGLE-TAG-WITHOUT-GTM']?.code?.length &&
          res?.data?.Pixel?.['GOOGLE-TAG-WITHOUT-GTM']?.label?.length
        ) {
          res?.data?.Pixel?.['GOOGLE-TAG-WITHOUT-GTM']?.code?.map(
            (code: string, index: number) => {
              if (
                code &&
                res?.data?.Pixel?.['GOOGLE-TAG-WITHOUT-GTM']?.label?.[index]
              ) {
                pixel.push(
                  new GoogleAdsTracker(
                    code,
                    res?.data?.Pixel?.['GOOGLE-TAG-WITHOUT-GTM']?.label?.[
                      index
                    ],
                  ),
                );
              }
            },
          );
        }
        if (res?.data?.Pixel?.['GOOGLE-TAG-MANAGER']?.code) {
          if (
            storeData?.ShopID === '9ff43a-25' ||
            storeData?.ShopID === '3bcb9d-c3'
          ) {
            pixel.push(
              new GTMTrackerCustom(
                res?.data?.Pixel?.['GOOGLE-TAG-MANAGER']?.code,
              ),
            );
          } else {
            console.log(
              'GTM code - non custom',
              res?.data?.Pixel?.['GOOGLE-TAG-MANAGER']?.code,
            );
            pixel.push(
              new GTMTracker(res?.data?.Pixel?.['GOOGLE-TAG-MANAGER']?.code),
            );
          }
        }
        if (storeData?.ShopID === 'h0s46u-5s') {
          console.log(
            '[convert] convert pixel init triggered storeData?.ShopID :',
            storeData?.ShopID,
          );
          pixel.push(new ConvertTracker('10017401-10017720', '100141660'));
        }
        //following code is commented for future use or in case we need to use it
        // const eventPublisher = EventPublisher.getInstance();
        // pixel.forEach((tracker: Tracker) => {
        //   tracker.Init();
        //   eventPublisher.subscribeAll(event => {
        //     tracker.TrackEvent(event);
        //   });
        // });
      }
      if (shopId && thankyouPagePixelStoreIds?.includes(shopId)) {
        pixel.push(new GTMTrackerForThakyouPage(['GTM-PK7LFVSH']));
      }
      setPixelEvent(pixel);
    } catch (error) {
      console.error('Error in intializing pixel data:', error);
    }
  };

  const handlePreloadError = (error: AxiosError) => {
    if (error?.response?.data) {
      const { StatusCode, Msg } = error?.response?.data as {
        StatusCode: number;
        Msg: string;
      };
      if (
        StatusCode === 404 &&
        Msg === 'Cart is empty' &&
        storeData?.DomainURL
      ) {
        window.location.href = `https://${storeData.DomainURL}`;
      } else if (
        error?.response?.status === 400 ||
        error?.response?.status === 404
      ) {
        setError(
          'There was a problem with your request. Please check your information and try again.',
        );
      } else {
        setError(
          'Something went wrong! Try refreshing the page or try again later!',
        );
      }
    } else {
      console.error('Error in handlePreloadError', error);
      setError(
        'Something went wrong! Try refreshing the page or try again later!',
      );
    }
  };

  const checkConfigData = (pageData: string, pageType: string) => {
    const configData = ConvertBase64ToJson(pageData);
    if (!isEmpty(configData)) {
      setPuckData(configData);
      let puckConfig;
      if (
        [
          PageType.UPSELL,
          PageType.CHECKOUT,
          PageType.CONFIRMATION,
          PageType.OTHER,
        ].includes(pageType)
      ) {
        puckConfig = checkoutConfig() as Config;
      } else {
        setError(
          'There was a problem with your request. Please check your information and try again.',
        );
      }
      setPuckConfig(puckConfig);
    }
  };

  const getPreUpsell = useCallback(async () => {
    try {
      dispatch(setPreUpsellLoading(true));
      if (!shopId || !cartId) {
        return;
      }

      const payload: GetPreCheckoutUpSellPayload = {
        Limit: 5,
        CartID: cartId,
        ShopID: shopId,
      };
      const res = await checkoutService.getPreCheckoutUpSells(payload);
      if (res?.status === 200 && res?.data?.Result)
        dispatch(setPreUpsellData(res.data.Result));
    } catch (error) {
      console.error('Error fetching pre-upsell data:', error);
    } finally {
      dispatch(setPreUpsellLoading(false));
    }
  }, [shopId, cartId]);

  const getStoreData = useCallback(async () => {
    if (!shopId) {
      setError(
        'Something went wrong! Try refreshing the page or try again later!',
      );
      return;
    }
    try {
      setLoading(pre => pre + 1);
      const res = await checkoutService.getStoreDetails(
        shopId,
        eventToken || '',
      );
      if (res?.status === 200 && res?.data) {
        if (isMockApi) {
          res.data.IsCardEncryption = false;
        }
        dispatch(setStoreData({ ...res.data }));
      } else {
        setStoreData({
          ...storeData,
          ShopID: '',
          StoreID: '',
          ShopURL: '',
          CustomerServiceEmail: '',
          CustomerServiceNumber: '',
        });
      }
    } catch (error) {
      handlePreloadError(error as AxiosError);
    } finally {
      setLoading(pre => pre - 1);
    }
  }, [shopId, handlePreloadError]);
  const input1: { shopId: string } = { shopId: shopId };
  const input: StartCheckoutPayload = {
    CartID: cartId || '',
    ShopID: shopId,
    TrafficSource: trafficSource || '',
  };

  const getPageDeatils = async () => {
    let message = '';
    let response = null;
    try {
      if (!shopId) {
        showNotification(
          StatusCode.failed,
          `Invalid ${shopId ? '' : 'store Id'}`,
        );
        return;
      }

      setLoading(pre => pre + 1);
      if (navStateID && purchaseToken) {
        const id =
          navStateID +
          (state?.pageVisiblity === 'DEFAULT'
            ? `?templateID=${navStateID}`
            : '');
        const response = await checkoutService.getPageById(
          id,
          smartFunnelId ?? '',
        );

        if (response?.status === 200 && response?.data?.Result) {
          checkConfigData(
            response?.data.Result?.pageData,
            response?.data.Result?.pageType,
          );
          dispatch(
            setNextPageConfig({
              id: response?.data?.Result?.nextPage?.id || '',
              pageType: response?.data?.Result?.nextPage?.pageType || '',
              pageVisiblity:
                response?.data?.Result?.nextPage?.pageVisiblity || '',
            }),
          );
        }
      } else {
        if (!cartId) {
          showNotification(
            StatusCode.failed,
            `Invalid ${cartId ? '' : 'cart Id'}`,
          );
          return;
        }
        // need to do only one time when checkout page is reached not for thankyou nad upsell pages
        getPixel();
        resetState();
        const payload: StartCheckoutPayload = {
          CartID: cartId,
          ShopID: shopId,
          TrafficSource: trafficSource || '',
          EventToken: eventToken || '',
          clickid: clickid || '',
          QueryParams: JSON.stringify(Object.fromEntries(searchParams)),
        };
        const uniqueEventId = uuidv4();
        const res = await checkoutService.getCheckout(payload, uniqueEventId);
        if (!getIsViewIsEdit?.()) {
          publish('InitiateCheckout', {
            eventName: 'InitiateCheckout',
            eventId: uniqueEventId,
            shopId: shopId,
            cart: res?.data?.Cart,
          });
          publish('PageView', {
            eventName: 'PageView',
            eventId: uniqueEventId,
            shopId: shopId,
            cart: res?.data?.Cart,
          });
          setPixelData({
            isEventHoisted: false,
            phxRequestId: uniqueEventId,
          });
        }
        if (res?.status === 200 && res?.data) {
          dispatch(setCallMetaApi(res?.data?.CallMetaApi));
          dispatch(setSalexTaxEnabled(res?.data?.salesTaxEnabled));
          dispatch(setCalculatedFeeEnabled(res?.data?.calculatedFeeEnabled));
          if (res?.data?.CallMetaApi) {
            handleCapi({
              eventName: 'InitiateCheckout',
              ShopID: shopId,
              Cart: res.data.Cart,
              eventId: uniqueEventId,
            });
          }

          if (res?.data?.ApplePay) {
            dispatch(setApplePay(res?.data?.ApplePay));
          }
          if (res?.data?.GooglePay) {
            dispatch(setGooglePay(res?.data?.GooglePay));
          }
          dispatch(setCountriesList(CountryWithStateList));
          getPreUpsell?.();
          getPostUpSells?.(res.data?.Cart);
          dispatch(setCartData(res.data?.Cart));
          dispatch(
            setAvailableShippingMethods(
              res?.data?.Cart?.AvailableShippingMethods as ShippingMethod[],
            ),
          );
          if (res?.data?.Cart?.AvailableShippingMethods?.length) {
            dispatch(
              setSelectedShippingMethod(
                res?.data?.Cart?.AvailableShippingMethods?.[0],
              ),
            );
          }

          if (res?.data?.Cart?.CartDiscounts) {
            dispatch(
              setPromoCodes(res?.data?.Cart?.CartDiscounts.map(d => d.Code)),
            );
          }
          dispatch(
            setCurrentPageFunnelId(res?.data?.Page?.funnelMappingId || ''),
          );
          dispatch(setPageId(res?.data?.Page?.id || null));
          dispatch(
            setNextPageConfig({
              id: res?.data?.Page?.nextPage?.id || '',
              pageType: res?.data?.Page?.nextPage?.pageType || '',
              pageVisiblity: res?.data?.Page?.nextPage?.pageVisiblity || '',
            }),
          );
          checkConfigData(res?.data?.Page?.pageData, res?.data?.Page?.pageType);
          try {
            await getCheckoutPageFromPageID();
          } catch (error) {
            console.error(
              'Error in getting page get Checkout Page From Page ID',
              error,
            );
          }
        }
        message = 'cart data loaded successfully';
        response = res.data;
      }
    } catch (error) {
      console.error('Error in getting page details', error);
      message = 'cart data failed to load';
      response = error;
      const errorResponse = error as IErrorResponse<AxiosError>;
      handlePreloadError?.(errorResponse.error as AxiosError);
    } finally {
      setLoading(pre => pre - 1);
      handleEventLogger({
        eventType: 'cart_load',
        shopifyDetails: {
          shopId: shopId,
          shopData: storeData,
        },
        apiDetails: {
          payload: input,
          response: response,
          message: message,
        },
        eventToken: eventToken || null,
      });
    }
  };

  const resetState = () => {
    dispatch(setCartData(null));
    dispatch(setApplePay(null));
    dispatch(setStoreData(null));
    dispatch(setApiLoading(false));
    dispatch(setAvailableShippingMethods([]));
    dispatch(setSelectedShippingMethod(null));
    dispatch(
      setNextPageConfig({
        id: '',
        pageType: '',
        pageVisiblity: '',
      }),
    );
    dispatch(setCountriesList([]));
    dispatch(setPreUpsellData(null));
    dispatch(setPostUpsellData(null));
    dispatch(setOrderDetails([]));
    dispatch(setPurchaseToken(''));
    dispatch(setCallMetaApi(false));
    dispatch(setSalexTaxEnabled(false));
    dispatch(setCheckoutErrorMessage(''));
    dispatch(setIsDeclinePopup(false));
    dispatch(setSubmitSuccess(false));
    dispatch(setIsCartLoading(false));
    dispatch(setPromoCodes(null));
    dispatch(setIsSetShippingApiLoading(0));
    dispatch(setCurrentUpsellData(null));
    dispatch(setIsLoading(false));
    dispatch(setUpsellData(null));
    dispatch(setSelectedUpsellItems([]));
    dispatch(setShowPopup(false));
    dispatch(setSelectedVariantForSingleProduct(null));
    dispatch(setSmartUpsellFunnelID(''));
    dispatch(setPageId(null));
    dispatch(setIsPaymentByPaypal(false));
  };

  const getOrderAndUpSellDetails = useCallback(async () => {
    try {
      if (
        !purchaseToken ||
        !shopId ||
        !cartId ||
        purchaseToken === '1234567890'
      ) {
        return;
      }
      const response =
        await checkoutService.getUpsellAndOrderDetails(purchaseToken);
      if (
        response?.status === 200 &&
        response?.data?.Result &&
        response?.data?.Result?.OrderDetails
      ) {
        dispatch(setOrderDetails(response?.data.Result?.OrderDetails));
        return;
      }
      dispatch(setOrderDetails([]));
    } catch (error) {
      dispatch(setOrderDetails([]));
      console.error('Error fetching order details:', error);
    }
  }, [purchaseToken, shopId, cartId]);
  const newSearchParams = new URLSearchParams(searchParams.toString());

  const sendOrderDetails = async () => {
    if (
      purchaseToken &&
      shopId &&
      cartData &&
      storeData?.StoreID &&
      storeData?.EnableClubOrder
    ) {
      const payload = {
        orderId: purchaseToken || '',
        mailId: cartData?.Email || '',
        storeCode: String(storeData?.StoreID ?? ''),
      };
      await checkoutService.sendOrderDetails(payload);
    }
  };

  const handleNavigate = () => {
    navigate('/' + '?' + newSearchParams.toString());
  };
  function onPopState(e: PopStateEvent) {
    e.preventDefault();
    console.log('Popstate event triggered');
    handleNavigate();

    // Remove the event listener after running
    window.removeEventListener('popstate', onPopState);
  }
  const isThankYouPage = state?.pageType === 'confirmation';
  const handleThakyouPageReaching = () => {
    if (isThankYouPage) {
      window.addEventListener('popstate', onPopState);
      if (purchaseToken) {
        getOrderAndUpSellDetails();
        sendOrderDetails();
        if (cartData && shopId && thankyouPagePixelStoreIds?.includes(shopId)) {
          publish('ThankYouPageReached', {
            eventName: 'ThankYouPageReached',
            eventId: 'GTM-PK7LFVSH',
            shopId: shopId,
            cart: cartData,
          });
        }
      }
      dispatch(setPostUpsellData(null));
    }
  };

  // get mock checkout page details from page id
  const getCheckoutPageFromPageID = async () => {
    if (
      !isMockApi ||
      !designID ||
      !DESIGN_ID_ENABLED_STORES?.includes(shopId)
    ) {
      return;
    }
    try {
      const res = await checkoutService.getCheckoutPageByStoreID(designID);
      if (res?.status === 200 && res?.data?.Page) {
        dispatch(
          setNextPageConfig({
            id: res?.data?.Page?.nextPage?.id || '',
            pageType: res?.data?.Page?.nextPage?.pageType || '',
            pageVisiblity: res?.data?.Page?.nextPage?.pageVisiblity || '',
          }),
        );
        checkConfigData(res?.data?.Page?.pageData, res?.data?.Page?.pageType);
      }
    } catch (error) {
      console.error('Error in getting page details', error);
    }
  };

  useEffect(() => {
    getStoreData();
    getPageDeatils();
    handleThakyouPageReaching();
  }, [searchParams, state]);

  useEffect(() => {
    getOrderAndUpSellDetails();
  }, [purchaseToken]);

  const getPostUpSells = async (cartData: Cart) => {
    if (shopId && cartId && cartData?.LineItems?.length > 0) {
      const productIds = cartData.LineItems.map(
        (cartLine: { ProductID: string }) => cartLine.ProductID,
      );

      const payload = {
        Limit: 10,
        ProductIDs: productIds,
        ShopID: shopId,
        CartId: cartId,
      };

      try {
        if (postUpsellPage?.includes(shopId)) {
          const res = await checkoutService.getPostCheckoutUpSells(payload);
          if (res?.status === 200 && res?.data?.Result?.data) {
            dispatch(setPostUpsellData(res.data.Result.data));
          }
        } else {
          const res = await checkoutService.getPostCheckoutUpSellsV2(payload);
          const keys = Object.keys(res.data.Result).filter(
            key => key !== 'smartUpsellFunnelID',
          );
          if (res?.data?.Result?.smartUpsellFunnelID) {
            dispatch(
              setSmartUpsellFunnelID(res.data.Result.smartUpsellFunnelID || ''),
            );
          }
          if (res?.status === 200 && res?.data?.Result) {
            dispatch(setUpsellData(res.data?.Result));
            dispatch(setCurrentUpsellData(res.data?.Result?.[keys[0]]));

            // don't remove this code as it is used for upsell page in upcoming

            if (res?.data?.Result) {
              dispatch(
                setNextPageConfig({
                  id: res.data?.Result?.[keys[0]]?.pageId,
                  pageType: 'upsell',
                  pageVisiblity: '',
                }),
              );
            }
          }
        }
      } catch (error) {
        console.error('Error fetching post-upsell data:', error);
      }
    }
  };

  extractAndUseTrackers(
    puckRootData?.pixelTracking,
    puckData != undefined,
    puckRootData?.isGlobalPixel || isThankYouPage,
    setPixelData,
    pixelEvent,
    metaTickTokTracker,
    pixelData?.phxRequestId,
  );

  useEffect(() => {
    if (
      pixelData?.isEventHoisted &&
      pixelData?.phxRequestId &&
      shopId &&
      cartData
    ) {
      publish('InitiateCheckout', {
        eventName: 'InitiateCheckout',
        eventId: pixelData?.phxRequestId,
        shopId: shopId,
        cart: cartData,
      });
      publish('PageView', {
        eventName: 'PageView',
        eventId: pixelData?.phxRequestId,
        shopId: shopId,
        cart: cartData,
      });
      setPixelData({
        isEventHoisted: false,
        phxRequestId: '',
      });
    }
  }, [pixelData?.isEventHoisted, shopId, cartData]);

  return (
    <>
      {loading ? (
        purchaseToken ? (
          <LoadingPage />
        ) : (
          <CheckoutSkeleton />
        )
      ) : error ? (
        <ErrorMessage errorMessage={error} />
      ) : (
        puckConfig &&
        puckData && <HomePage config={puckConfig} data={puckData} />
      )}
    </>
  );
};

export default Home;
